import { useContext } from 'react';
import SchoolStatisticGrid from './SchoolStatisticGrid';
import ViewFileLogs from './ViewFileLogs';
import { SmartContext } from '../../../library/Core/SmartContext';

const SchoolStatisticsReport = () => {
    const { state, dispatch } = useContext(SmartContext);
    console.log("state",state)
    const summaryCardsControl = [
        { 
            id: 'totalAlumniCount', 
            label: 'Total Alumni Count', 
            count : state?.data?.schoolCount[0]?.totalAlumniCount,
        },
        { 
            id: 'rawDataFields', 
            label: 'Average Fields', 
            title: "Before vs After",
            // count : state?.data?.schoolCount[0]?.rawDataFieldsSummary,
            count: (() => {
                console.log(" state?.data?.schoolCount: 20 :: ", state?.data?.schoolCount)
                const receivedFieldCount = state?.data?.schoolCount[0]?.receivedFieldCount || 0;
                const totalAlumniCount = state?.data?.schoolCount[0]?.totalAlumniCount || 0;
                const totalUpdatesCount = state?.data?.schoolCount[0]?.totalUpdatesCount || 0;
                const totalAlumniCountDb = state?.data?.schoolCount[0]?.totalAlumniCountDb || 0;
                
                const first = totalAlumniCount > 0 ? Math.round(receivedFieldCount / totalAlumniCount) : 0;
                const second = totalAlumniCountDb > 0 ? Math.round(totalUpdatesCount / totalAlumniCountDb) : 0;

                // return (<b>{first} vs {second}</b>);
                return (<>{first} vs {second}</>);
            })()

        },
        { 
            id: 'totalUpdatesCount', 
            label: 'Data Points', 
            title: "Before vs After",
            count: (() => {
                // `${state?.data?.schoolCount[0]?.receivedFieldCount} / ${state?.data?.schoolCount[0]?.totalUpdatesCount}`
                return (<span>{state?.data?.schoolCount[0]?.receivedFieldCount} vs {state?.data?.schoolCount[0]?.totalUpdatesCount}</span>)
            })()
        },
        { 
            id: 'avgCompletionPercentage', 
            label: 'Average Growth %', 
            count :state?.data?.schoolCount[0]?.avgCompletionPercentage
        }, 
        { 
            id: 'filesInsertedCount', 
            label: 'Received Files', 
            count :state?.data?.schoolCount[0]?.filesInsertedCount
        }, 
        // { 
        //     id: 'filesUpdatedCount', 
        //     label: 'Updated Data Files uploaded count', 
        //     count :state?.data?.schoolCount[0]?.filesUpdatedCount
        // }, 

    ];

    return (
        <>
          <div className="main flex-1">
            <div className="fixed_srtipe" style={{ display: 'none' }}>
                <i className="reg-srtipe" style={{ height: '342.2px' }}></i>
                <i className="filter-srtipe" style={{ height: '469.8px' }}></i>
            </div>
            <div className="container px-lg-0 overflow-hiddens">
                <div className="white-block white-block-notopborderradius p-0 h-100">
                    <div className="row g-3 mb-3 align-items-center p-4">
                         <div className="univarsity_logo manager_profile col-auto">
                                    <div className="logo">
                                        <button
                                            className="mobileonly btn-offcanvas"
                                            type="button"
                                            data-bs-toggle="offcanvas"
                                            data-bs-target="#offcanvasMobile"
                                            aria-controls="offcanvasMobile">
                                            <span className="navbar-toggler-icon">
                                                <b>#</b>
                                            </span>
                                        </button>
                                        <img src={state?.data?.schoolCount[0]?.logo} width="160" alt="" className="img-fluid" />
                                    </div>
                                </div>
                        <div className="col-md-7">
                            <div className="d-flex flex-column">
                                <h3 className="font-28 font-600 mb-0 block-title">
                                {state?.data?.schoolCount[0]?.schoolName}
                                </h3>
                            </div>
                        </div>

                    </div>
                    {/* count cards */}
                      <section className="bg-red pt-3 pt-sm-5 pb-3 container-fluid" id="alumni_directory">
                        <div className="px-4">
                                <div className="row">
                                    <div className="aldir_scroll active">
                                        <div className="row min-100per">
                                            {summaryCardsControl.map((control: any) => (
                                                <div key={control.id} className="col mb-4 aldir_box smart-tooltip" data-bs-toggle="tooltip" data-bs-title={control.title}>
                                                    <div
                                                        className="bg-white rounded alumni-directory-block h-100"
                                                        role="button">
                                                        <div className="number font-28 font-600 d-flex justify-content-between align-items-center">
                                                            {control.count}
                                                        </div>
                                                        <div className="d-flex justify-content-between">
                                                            <div className="font-16 font-500 flex-1">{control.label}</div>
                                                          
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </section>
                    {state?.data?.fieldList?.length > 0 && (
                        <SchoolStatisticGrid fieldList={state.data.fieldList} />
                    )}
                    <ViewFileLogs />
                </div>
            </div>
        </div>

       
        </>
        
    );
};

export default SchoolStatisticsReport;
